import React from "react";

import { EnergyGenerationAndDistribution } from "./components/energy-generation-and-distribution";
import { IntroducingSavantPower } from "./components/introducing-savant-power";
import { IntroducingSavantPowerBanner } from "./components/introducing-savant-power-banner";
import { Flm } from "./components/flexible-load-management";
import { FlexibleMicroGrid } from "./components/flexible-micro-grid";
import { EnergyIndependence } from "./components/energy-independence";
import { EnvironmentalStewardship } from "./components/environmental-stewardship";
import { EnergyMonitoring } from "./components/energy-monitoring";
import { PowerMove } from "./components/power-move";

const indexElement = (
  <div>
    <IntroducingSavantPowerBanner />
    <IntroducingSavantPower />
    <EnergyGenerationAndDistribution />
    <Flm />
    <FlexibleMicroGrid />
    <EnergyIndependence />
    <EnvironmentalStewardship />
    <EnergyMonitoring />
    <PowerMove />
  </div>
);

export function Index() {
  return indexElement;
}
